import React from 'react';
import { Outlet } from 'react-router-dom';
import { useContext } from 'react';
import AuthContext from '../../utils/AuthProvider';

const PersistLogin = () => {
    const { loading } = useContext(AuthContext);

    if (loading) {
        return <p>Loading...</p>;
    }

    return <Outlet />;
};

export default PersistLogin;